// extracted by mini-css-extract-plugin
export default {"FeaturesTable":"FeaturesTable-module__FeaturesTable--qIE3p","FeaturesTable__srOnly":"FeaturesTable-module__FeaturesTable__srOnly--zHyC_"};